import { useCallback } from 'react';

import { useUpdateUser, useUser } from 'apps/shared/scripts/graphql';
import { useFormCallback } from 'apps/shared/scripts/hooks';

import { AccountSettingsForm, LoadingSettings } from '../../components';
import { AccountSettingsFormValues } from '../../components/AccountSettingsForm';
import { getDefaultValues } from '../../utils';

const AccountSettingsFormContainer = () => {
  const { isMutating: isUpdating, mutate: updateUser } = useUpdateUser({
    refetchQueries: ['UserQuery'],
    awaitRefetchQueries: true,
  });
  const { isLoading, user } = useUser();
  const { onSuccess, onError } = useFormCallback();

  const onSubmit = useCallback(
    async (data: AccountSettingsFormValues) => {
      try {
        const { result, errors } = await updateUser({ input: data });
        if (!result || errors.length > 0) {
          throw new Error(errors[0].message);
        }
        onSuccess({ message: 'Success! Account was updated' });
      } catch (e) {
        onError(e);
        throw e;
      }
    },
    [onError, onSuccess, updateUser],
  );

  if (isLoading || !user) {
    return <LoadingSettings />;
  }

  return (
    <AccountSettingsForm
      defaultValues={getDefaultValues(user)}
      isSubmitting={isUpdating}
      onSubmit={onSubmit}
    />
  );
};

AccountSettingsFormContainer.displayName = 'AccountSettingsFormContainer';

export default AccountSettingsFormContainer;
